import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FiltersSection({ children, table }) {
    return (_jsxs("div", { className: "space-y-4", children: [_jsx("div", { className: "relative z-40 overflow-visible", children: children }), _jsx("div", { className: "relative z-10", children: table })] }));
}
